import React from 'react';

const About = () => {
    return (
        <div>
            <h2>This is the about components</h2>
        </div>
    );
};

export default About;